import React, { useState, useEffect } from "react";
import Header from "./Header";
import Leftnavbar from "./Leftnavbar";
import Main from "../main/Main";
import Rightsidebar from "./Rightsidebar";
import "./Layout.css";
import axios from "axios";

export default function Layout() {
  const [patients, setPatients] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const token = "Y29hbGl0aW9uOnNraWxscy10ZXN0";
  useEffect(() => {
    const fetchPatients = async () => {
      try {
        const token = "YOUR_ACTUAL_TOKEN_HERE";
        const response = await axios.get(
          "https://fedskillstest.coalitiontechnologies.workers.dev",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Basic ${"Y29hbGl0aW9uOnNraWxscy10ZXN0"}`,
            },
          }
        );

        if (response.status === 200) {
          setPatients(response.data);
          if (response.data.length > 0) {
            setSelectedPatient(response.data[3]);
          }
        } else {
          console.error("Unexpected response status:", response.status);
        }
      } catch (error) {
        console.error("Error fetching patient data:", error);
        if (error.response) {
          console.error("Response data:", error.response.data);
        }
      }
    };

    fetchPatients();
  }, []);

  return (
    <>
      <Header />
      <div className="main-layout">
        <Leftnavbar
          patients={patients}
          setSelectedPatient={setSelectedPatient}
        />
        <Main selectedPatient={selectedPatient} />
        <Rightsidebar selectedPatient={selectedPatient} />
      </div>
    </>
  );
}
